import submitSpinner from './epiforms__submit-spinner';

export default function exec () {
    submitSpinner();
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/epiforms/index.js